import { createStore, type StoreOptions } from 'vuex'
import UserModule from './user'
import MapModule from './map'
import DevicesModule from './devices'
import DevicesModelsModule from './devicemodels'
import AlertModule from './alerts'
import SubscriptionsModule from './subscriptions'
import AdminPanelModule from './adminpanel'
import DeveloperPanelModule from './developerpanel'
import DeviceIntervalsModule from './device-intervals'
import { NAMESPACES } from './types'
import type { UserState } from './user/types'
import type { MapState } from './map'
import type { DevicesState } from './devices'
import type { DeviceModelsState } from './devicemodels'
import type { AlertsState } from './alerts'
import type { SubscriptionsState } from './subscriptions'
import type { AdminPanelState } from './adminpanel'
import type { DeveloperPanelState } from './developerpanel'
import type { DeviceIntervalsState } from './device-intervals'

export type RootState = {
  releaseVersion: string

  // Module states
  [NAMESPACES.USER]?: UserState
  [NAMESPACES.MAP]?: MapState
  [NAMESPACES.DEVICES]?: DevicesState
  [NAMESPACES.DEVICE_MODELS]?: DeviceModelsState
  [NAMESPACES.ALERTS]?: AlertsState
  [NAMESPACES.SUBSCRIPTIONS]?: SubscriptionsState
  [NAMESPACES.ADMIN_PANEL]?: AdminPanelState
  [NAMESPACES.DEVELOPER_PANEL]?: DeveloperPanelState
  [NAMESPACES.DEVICE_INTERVALS]?: DeviceIntervalsState
}

const root: StoreOptions<RootState> = {
  state: {
    releaseVersion: APP_VERSION
  },
  modules: {
    [NAMESPACES.USER]: UserModule,
    [NAMESPACES.MAP]: MapModule,
    [NAMESPACES.DEVICES]: DevicesModule,
    [NAMESPACES.DEVICE_MODELS]: DevicesModelsModule,
    [NAMESPACES.ALERTS]: AlertModule,
    [NAMESPACES.SUBSCRIPTIONS]: SubscriptionsModule,
    [NAMESPACES.ADMIN_PANEL]: AdminPanelModule,
    [NAMESPACES.DEVELOPER_PANEL]: DeveloperPanelModule,
    [NAMESPACES.DEVICE_INTERVALS]: DeviceIntervalsModule
  }
}

export default createStore(root)

export { NAMESPACES }
